{
  "en": {
    "features": {
      "aftercare": "Aftercare",
      "ai_assistant": "AI Assistant",
      "aftercare_customer_feedback": "Aftercare: request customer approval",
      "aftercare_customer_issue_creation": "Aftercare: customer can create issues",
      "announcements": "News",
      "conversation_mentions": "Conversation: notes and mentions",
      "customers": "Information: multiple customers per unit",
      "decisions_core": "Decisions: Core",
      "decisions_financials_extended": "Decisions: financials extended",
      "decisions_financials": "Decisions: financials",
      "decisions_documents": "Decisions: documents",
      "decisions_tickets": "Decisions: conversations",
      "decisions_reminders": "Decisions: reminders",
      "decisions_partners": "Decisions: partners",
      "decisions_proposals_multiple_approval": "Decisions: multiple proposals approval",
      "proposal_choice_lists": "Decisions: choice lists",
      "document_categories": "Documents: custom categories",
      "documents": "Documents",
      "email_forwarding_client": "Email Forwarding: client",
      "email_forwarding_project": "Email Forwarding: project",
      "employee_import_customers": "Import: Customers (Employee)",
      "employee_import_spaces": "Import: Spaces (Employee)",
      "employee_import_units": "Import: Units (Employee)",
      "faqs": "FAQs",
      "inspirations": "Inspirations",
      "financials": "Financials",
      "information_full": "Information: RED forms",
      "milestones": "Milestones",
      "mobile_app_customer": "Mobile App Customer",
      "multilingual": "Multilingual",
      "project_partners": "Projects: partners",
      "project_subdomains": "Projects: subdomains",
      "proposal_subchoices": "Decisions: subchoices",
      "proposal_templates": "Decisions: proposal templates",
      "sales": "Sales",
      "sales_partners": "Sales: partners",
      "snippets": "Snippets",
      "surveys": "Surveys",
      "template_projects": "Projects: templates",
      "ticket_categories": "Conversations: categories",
      "tickets": "Conversations",
      "todos": "Tasks"
    },
    "feature_descriptions": {
      "decisions_core": "Includes simple proposals (without gross offer and other financials), signatures",
      "decisions_financials": "Includes gross offer, net offer, budget, surcharge, negative surcharge allowed",
      "decisions_proposals_multiple_approval": "Allows the approval of multiple proposals",
      "information_full": "Includes all information fields (e.g. unit specifications, prices, etc)",
      "aftercare_customer_feedback": "Client needs to turn this on under company settings",
      "aftercare_customer_issue_creation": "Client needs to turn this on within the aftercare module",
      "decisions_financials_extended": "Includes extra budget, margin budget and margin extra budget",
      "email_forwarding_project": "Only for MUPs"
    }
  }
}
